<template>
	<div class="comments">
		<div class="comments-item">
			<div class="comments-title-row">
				<img class="comments-avatar" v-if="comment.user" :src="$helpers.isJson(comment.user.avatar) ? ($helpers.api_url() + $helpers.json_pars(comment.user.avatar).name) : 'https://static.tgju.org/views/default/images/avatar.jpg'">
				<img class="comments-avatar" v-else :src="'https://static.tgju.org/views/default/images/avatar.jpg'">
				<router-link v-if="comment.user" :to="{ name: 'ProfileOthers' , params:{ username : comment.user.username }}"  class="comments-user">
					{{ comment.user.firstname + ' ' + comment.user.lastname }}
				</router-link>
				<span v-else class="comments-user">
					{{ comment.name }}
				</span>
				<div class="flex-grow-1"></div>

				<div class="comments-date" v-tooltip="'تاریخ ارسال دیدگاه'"><i class="uil uil-clock"></i> {{ toRelative(comment.created_at) }}</div>
				<div class="comments-actions" v-if="user && ($helpers.userInfo().id == comment.user.id) ">
					<dropdown-menu v-model="showMenu">
						<a href="#" class="post-btn share dropdown-toggle" @click.prevent="" v-tooltip="'مدیریت'">
							<i class="uil uil-ellipsis-v" aria-hidden="true"></i>
						</a>

						<div slot="dropdown">
							<span class="dropdown-item" @click="goEditComment(comment.id)"><i class="uil uil-edit-alt" aria-hidden="true"></i> ویرایش</span>
							<span class="dropdown-item" @click="removeComment(comment.id)"><i class="uil-trash-alt" aria-hidden="true"></i> حذف</span>
						</div>
					</dropdown-menu>
				</div>
			</div>
			<div class="comments-content" v-html="comment.content"></div>
			<div class="comments-footer">
				<div class="post-btn-item pointer" v-if="user"  v-tooltip="'لایک دیدگاه'">
					<i class="uil uil-thumbs-up post-btn-icon" style="color: #db332f;" v-if="comment.liked" @click="likeComment(comment.id)"></i>
					<i class="uil uil-thumbs-up post-btn-icon" aria-hidden="true" v-else @click="likeComment(comment.id)"></i>
					<span class="post-btn-count">{{ comment.likes }}</span>
				</div>
				<div class="flex-grow-1"></div>
				<div class="post-btn-item pointer" v-if="user" @click="goReplyComment(comment.id)" v-tooltip="'ارسال پاسخ به دیدگاه'">
					<i class="uil uil-comment-medical post-btn-icon "></i>
					<span class="post-btn-reply">پاسخ</span>
				</div>
			</div>
		</div>
		<div class="comments-list" v-for="childComment in comment.comments" :key="childComment.id">
			<CommentItem :comments="comment.comments" :comment="childComment" :subject="subject"></CommentItem>
		</div>
	</div>
</template>


<script>
	import moment from "moment-jalaali";
	import DropdownMenu from '@innologica/vue-dropdown-menu';


	export default {
		name: 'CommentItem',
		components: {
			DropdownMenu
		},
		props: ['comments', 'comment', 'subject'],
		data: function () {
			return {
				user : this.$helpers.userSync(),
				showMenu : false		
			}
		},

		computed: {
			newPost: {
				get() {
					return this.$parent.newPost;
				},
				set(value) {
					this.$parent.newPost = value;
				}
			},
		},

		watch: {
			comment: {
				handler: function (newValue, oldValue) {
					if ( Object.keys(newValue).length ) {
						this.showMenu = false;
						this.showShareMenu = false;
						
						// if(this.$helpers.isJson(this.comment.user.avatar)) {
						// 	this.comment.user.avatar = this.$helpers.api_url() + this.$helpers.json_pars(this.comment.user.avatar).name
						// } else {
						// 	this.comment.user.avatar = 'https://static.tgju.org/views/default/images/avatar.jpg';
						// }

						this.comment.content = this.comment.content.replaceAll(/<br><img class="post-img".*?>/gmi, '');
						if ( this.comment.attachments.length ) {
							this.comment.content += `<br><img class="post-img" src="${this.$helpers.api_url() + this.comment.attachments[0].name}">`;
						}
					}
				},
				immediate: true
			}
		},

		mounted() {
			this.$root.$on('LoginCallBack', (data) => {
				this.user = this.$helpers.userSync();
			});
		},

		methods: {

			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},

			likeComment(id) {
				let index = this.$helpers.getIndex(this.comments, id);
				let comment = this.comments[index];

				let api_data = {
					action: comment.liked ? 'unlike' : 'like'
				};

				this.$helpers.makeRequest('GET', '/tgju-post/like/' + id, api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						comment.liked = !comment.liked;
						comment.likes = api_response.data.response.likes;
					}
				});
			},

			goReplyComment(id) {
				let index = this.$helpers.getIndex(this.comments, id);
				let comment = this.comments[index];

				this.newPost.parent_id = id;
				this.newPost.parent = comment;
				this.newPost.content = '@' + this.newPost.parent.user.username;
				this.newPost.type = 'tgju-comment';

				let parent = this.$helpers.getParent(this);

				parent.askParentToSetReply(this.newPost);
				// parent.askParentToScrollTo('#global-dashboard-modal[data-component="PostComments"]');
			},

			removeComment(id) {
				let index = this.$helpers.getIndex(this.comments, id);

				this.$helpers.confirm('هشدار حذف!', {
					message: 'آیا از حذف این مورد اطمینان دارید؟',
				}).then((confirmed) => {
					if ( confirmed ) {
						this.$helpers.makeRequest('DELETE', '/tgju-post/delete/' + id).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.status == 200 ) {
								this.comments.splice(index, 1);
							}
						});
					}
				});
			},
			goEditComment(id) {
				let index = this.$helpers.getIndex(this.comments, id);
				let comment = this.comments[index];

				this.newPost.id = id;
				this.newPost.content =  comment.content.replaceAll(/<br><img class="post-img".*?>/gmi, '');
				this.newPost.type = 'tgju-comment';
				this.newPost.attachments = comment.attachments;

				let parent = this.$helpers.getParent(this);
				parent.askParentToEditComment(this.newPost);
				
			},
		}
	}
</script>
